import React from 'react';

import { OptionType } from '@/typings/common';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarLocations,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function LocationFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedLocation =
    useTypedSelector(getSelectedFilters).selectedParams.selectedLocation;

  const locationsOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'locations'
  );

  const handleChangeLocation = (location: OptionType) => {
    dispatch(
      setCarLocations(handleChangeMultiSelect(location, selectedLocation))
    );
    dispatch(setPage(1));
  };

  const handleClearLocation = () => {
    dispatch(setCarLocations([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Локация"
      options={locationsOptions}
      selectedOptions={selectedLocation}
      onChange={handleChangeLocation}
      onClear={handleClearLocation}
    />
  );
}

export default LocationFilter;
